(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
(function() {
  const articles = document.querySelectorAll('.js-article-content');

  articles.forEach(function(content) {
    const newsletter = content.parentElement.querySelector('[data-inline-newsletter]');
    if (!content || !newsletter) return;

    const paragraphs = Array.from(content.querySelectorAll('p'));
    if (!paragraphs.length) return;

    // Choose the middle paragraph as the insert point
    const insertIndex = Math.floor(paragraphs.length / 2);
    const target = paragraphs[insertIndex];
    if (!target) return;

    target.insertAdjacentElement('afterend', newsletter);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
